import { CashRequestDetail } from "@/pages/requests/cash/schema/cash-requests.schema";
import { AppColors } from "@/styles/colors";
import { Flex, Text } from "@chakra-ui/react";
import dayjs from "dayjs";
import { v4 } from "uuid";
import "dayjs/locale/es";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale("es");

interface Props {
  request?: CashRequestDetail | null;
}

export const CashRequestMessageList = ({ request }: Props) => {
  return (
    <Flex
      flexDir="column"
      gap="25px"
      overflowY="auto"
      css={{
        "@media (max-width: 1350px) and (min-width: 1272px)": {
          maxHeight: "65px",
        },
        "@media (max-width: 1414px) and (min-width: 1351px)": {
          maxHeight: "128px",
        },
        "@media (max-width: 1590px) and (min-width: 1415px)": {
          maxHeight: "175px",
        },
        "@media (max-width: 1696px) and (min-width: 1591px)": {
          maxHeight: "200px",
        },
        "@media (max-width: 1900px)": {
          maxHeight: "400px",
        },
      }}
    >
      {request?.mensajes?.map((msg) => {
        return (
          <Flex
            key={v4()}
            flexDir="column"
            paddingX="24px"
            borderLeft={`4px solid ${
              msg?.esUsted
                ? AppColors.BLACK_TEXT_SECONDARY
                : AppColors.WHITE_BORDER_1
            }`}
          >
            <Text
              fontWeight={400}
              css={{
                "@media (max-width: 1350px) and (min-width: 1272px)": {
                  fontSize: "12px",
                },
                "@media (max-width: 1414px) and (min-width: 1351px)": {
                  fontSize: "14px",
                },
                "@media (max-width: 1590px) and (min-width: 1415px)": {
                  fontSize: "14px",
                },
                "@media (max-width: 1696px) and (min-width: 1591px)": {
                  fontSize: "16px",
                },
                "@media (max-width: 1900px)": {
                  fontSize: "16px",
                },
              }}
            >
              {msg.texto}
            </Text>
            <Text fontWeight={400} fontSize="12px" color={AppColors.GRAY_TEXT}>
              {dayjs
                .utc(request?.mensajes?.[0].fechaHora)
                .tz("America/Argentina/Buenos_Aires")
                .format("DD/MM/YYYY - HH:mm")}{" "}
              - {msg.usuario}
            </Text>
          </Flex>
        );
      })}
    </Flex>
  );
};
